import React, { useState } from 'react';
import { Card } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import nodata from '../../../../assest/images/No data-pana.svg'

const ResourceAllocation = ({ dashboardData }) => {
    const navigate = useNavigate();

    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

    const tableContainerStyle = {
        maxHeight: "250px",
        overflowY: "auto",
        display: "block",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
    };

    const tableStyle = {
        width: "100%",
        borderCollapse: "collapse",
        fontSize: "10px",
    };

    const thTdStyle = {
        border: "1px solid #ddd",
        padding: "10px",
        textAlign: "left",
    };

    const headerStyle = {
        ...thTdStyle,
        backgroundColor: "#004a78",
        fontWeight: "bold",
        color: "white",
        position: "sticky",
        top: 0,
        zIndex: 1,
        cursor: "pointer",
    };

    const data = dashboardData?.resource_details || [];

    // Sorting logic
    const sortedData = React.useMemo(() => {
        let sortableData = [...data];
        if (sortConfig.key !== null) {
            sortableData.sort((a, b) => {
                if (a[sortConfig.key] < b[sortConfig.key]) {
                    return sortConfig.direction === "asc" ? -1 : 1;
                }
                if (a[sortConfig.key] > b[sortConfig.key]) {
                    return sortConfig.direction === "asc" ? 1 : -1;
                }
                return 0;
            });
        }
        return sortableData;
    }, [data, sortConfig]);

    const handleSort = (key) => {
        let direction = "asc";
        if (sortConfig.key === key && sortConfig.direction === "asc") {
            direction = "desc";
        }
        setSortConfig({ key, direction });
    };

    const handleResourceNavigate = (resourceId) => {
        navigate('/employee-dashboard', { state: { resourceId } });
    };

    return (
        <Card sx={{ height: "250px" }}>
            <div style={tableContainerStyle}>
                <table style={tableStyle}>
                    <thead>
                        <tr>
                            <th style={{ ...headerStyle, cursor: "default" }}>Resource</th>
                            <th style={headerStyle} onClick={() => handleSort("rui")}>
                                RUI {sortConfig.key === "rui" ? (sortConfig.direction === "asc" ? "▲" : "▼") : ""}
                            </th>
                            <th style={headerStyle} onClick={() => handleSort("rpi")}>
                                RPI {sortConfig.key === "rpi" ? (sortConfig.direction === "asc" ? "▲" : "▼") : ""}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedData.length > 0 ? (
                            sortedData.map((row, i) => (
                                <tr key={i}>
                                    <td
                                        style={{ ...thTdStyle, cursor: "pointer" }}
                                        onClick={() => handleResourceNavigate(row.user_id)}
                                    >
                                        {row.resource_name}
                                    </td>
                                    <td style={thTdStyle}>{row.rui}</td>
                                    <td style={thTdStyle}>{row.rpi}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td
                                    colSpan={3}
                                    style={{
                                        textAlign: "center",
                                        padding: "25px",
                                        fontSize: "15px",
                                        color: "#555",
                                        fontStyle: "italic",
                                        border: "1px solid #ddd",
                                    }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            gap: "10px",
                                        }}
                                    >
                                        <img
                                            src={nodata}
                                            alt="No data"
                                            style={{ width: "110px", height: "110px" }}
                                        />
                                        <span style={{ fontSize: "14px", fontFamily: 'Montserrat, sans-serif' }}>No resource data found</span>
                                    </div>
                                </td>
                            </tr>
                        )}
                    </tbody>

                </table>
            </div>
        </Card>
    );
};

export default ResourceAllocation;
